import { Office, OfficeCreateDto, OfficeDeadlineEventSender, OfficeMin, OfficeUpdateDto } from 'types/offices';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIOfficesSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['Offices', 'OfficesMin', 'OfficesAll'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getOfficeById: builder.query<Office, string>({
                query: (id) => `/v1/offices/${id}`,
                keepUnusedDataFor: 0,
            }),
            getMinOfficesWithFilters: accumulatedQueryWithFilters<OfficeMin>(builder, '/v1/offices/min', {
                providesTags: ['OfficesMin'],
            }),
            getOfficesWithFilters: accumulatedQueryWithFilters<Office>(builder, '/v1/offices', {
                providesTags: ['Offices'],
            }),
            getOfficeDeadlineEventSender: builder.query<OfficeDeadlineEventSender, void>({
                query: () => `/v1/offices/deadline-event-sender`,
            }),
            getAllOffices: builder.query<Office[], void>({
                query: () => `/v1/offices`,
                keepUnusedDataFor: 5 * 60, // Cache for 5 minutes
                providesTags: ['OfficesAll'],
            }),
            addOffice: builder.mutation<Office, OfficeCreateDto>({
                query: ({ ...body }) => ({
                    url: `/v1/offices`,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['Offices', 'OfficesMin', 'OfficesAll'],
            }),
            updateOffice: builder.mutation<Office, OfficeUpdateDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/offices/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: ['Offices', 'OfficesMin', 'OfficesAll'],
            }),
            deleteOffice: builder.mutation<boolean, { id: string }>({
                query: ({ id }) => ({
                    url: `/v1/offices/${id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['Offices', 'OfficesMin', 'OfficesAll'],
            }),
        }),
        overrideExisting: false,
    });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetOfficeByIdQuery,
    useGetAllOfficesQuery,
    useGetOfficeDeadlineEventSenderQuery,
    useGetOfficesWithFiltersQuery,
    useGetMinOfficesWithFiltersQuery,
    useLazyGetMinOfficesWithFiltersQuery,
    useLazyGetOfficesWithFiltersQuery,
    useAddOfficeMutation,
    useUpdateOfficeMutation,
} = APIOfficesSlice;
